<template>
    <div id="app">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
html,
body {
    overflow: hidden;
    margin: 0;
    padding: 0;
    padding-right: 0 !important;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue